import axios from 'axios';
import getSecret from '../getSecret';

const API_BASE = process.env.REACT_APP_AESTHETIC_API_URL || 'https://wimages.salusemr.com';

async function getAuthHeaders() {
  try {
    const { token } = await getSecret('salusemr-token');
    return { Authorization: `Bearer ${token}` };
  } catch {
    return {};
  }
}

export async function simulateCosmeticSurgery(formData) {
  const headers = await getAuthHeaders();
  const response = await axios.post(`${API_BASE}/api/simulate`, formData, { headers });
  return response.data;
}
